import { render, staticRenderFns } from "./Layout5.vue?vue&type=template&id=b1d605de&scoped=true&"
import script from "./Layout5.vue?vue&type=script&lang=js&"
export * from "./Layout5.vue?vue&type=script&lang=js&"
import style0 from "./Layout5.vue?vue&type=style&index=0&id=b1d605de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d605de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
